// extracted by mini-css-extract-plugin
export default {"cosmicCard":"cosmicCard_cosmicCard__JHvde","floatIn":"cosmicCard_floatIn__jUjQo","scroll":"cosmicCard_scroll__9-SPb"};